export const sierraConfig = {
  preload: 'timeout',
  customGreeting:
    "Hello! I'm Alex, Fubo's Virtual Assistant.\n\nHow can I help today?\n\nEnter a message into the box below about what you'd like help with.",
  customGreetingMultipleMessages: true,
  display: 'corner',
  dimensions: {
    width: '25rem',
    height: '40rem',
  },
  logoSVG:
    "<svg width='56' height='23' viewBox='0 0 56 23' fill='none' role='img' xmlns='http://www.w3.org/2000/svg' xml:space='preserve' aria-label='fubo logo' data-testid='fubo-logo'><title>fubo logo</title><path fill='#FF3A03' d='M21.3 14.7c0 1.5 0 4-2.9 4s-3-2.6-3-4V6.5h-4.2v8.1c0 5.1 2 7.8 7 7.8 1.6 0 2.5-.5 3.1-.9v.7h4.2V6.5h-4.2v8.2zM6.6 5.5c0-1.1.9-1.2 1.3-1.2h.9L9.5.6C5 .1 4 1.2 3.1 2.2c-.7 1-.8 2.3-.8 3.2v1.1H0v3.7h2.3v11.9h4.2V10.3h3.1V6.5h-3v-1zM47.7 6.2c-1.9 0-3.7.7-5.1 1.8.9 1 1.6 2.2 2 3.5.8-.9 1.9-1.5 3.1-1.5 2.3 0 4.1 2 4.1 4.4 0 2.4-1.8 4.4-4.1 4.4s-4.1-1.9-4.1-4.3c0-2.1-.8-4-2.1-5.4-1.5-1.7-3.7-2.7-6.1-2.7-1.5 0-2.9.4-4.2 1.1V.8l-4.2.7v20.6h4.2v-.7c1.2.7 2.6 1 4.2 1 1.9 0 3.7-.7 5.1-1.8-.9-1-1.6-2.2-2-3.5-.7 1-1.9 1.6-3.1 1.6-2.3 0-4.1-2-4.1-4.5s1.8-4.5 4.1-4.5 4.1 2 4.1 4.5c0 2.1.8 4 2.1 5.4.1.1.1.2.2.2.9.9 2 1.6 3.2 2 .9.3 1.8.5 2.8.5 4.6 0 8.3-3.6 8.3-8.1-.1-4.4-3.8-8-8.4-8z'></path></svg>",
  titleBarLogoOnly: false,
  canRenderMessageImages: false,
  colors: {
    background: '#ffffff',
    text: '#10121A',
    border: '#C8CCDF',
    titleBar: '#000215',
    titleBarText: '#C8CCDF',
    assistantBubble: '#242733',
    assistantBubbleText: '#FAFBFF',
    userBubble: '#C8CCDF',
    userBubbleText: '#10121A',
  },
  type: {
    fontFamily: 'FT Regola Neue, sans-serif',
    fontSize: 16,
    fontSize900: 16,
    fontSize750: 16,
    fontSize500: 16,
    titleBarFontWeight: 600,
    titleBarLetterSpacing: 0.1,
  },
  chatInterfaceStrings: {
    name: 'Alex',
    disclosure:
      'Any personal information collected during this chat will be handled according to our [Privacy Policy](https://legal.fubo.tv/policies/?name=privacy-policy)',
    inputPlaceholder: 'Write a message',
    errorMessage: 'Oops, something went wrong! Please try again.',
    agentTransferWaitingMessage: 'Waiting for agent…',
    agentTransferQueueSizeMessage:
      'There are {QUEUE_SIZE} people in line ahead of you',
    agentTransferQueueNextMessage: 'You are next in line',
    agentJoinedMessage: 'Agent connected',
    agentLeftMessage: 'Agent left the chat',
    conversationEndedMessage: 'Chat ended',
    endConversationMenuLabel: 'End chat',
    printTranscriptMenuLabel: 'Print transcript',
    newTabScreenReaderText: '(opens in a new tab)',
  },
  canEndConversation: true,
  canStartNewChat: true,
  canPrintTranscript: true,
  hideOnClose: false,
  customStyle: {
    zIndex: 3001,
  },
  launcher: {
    backgroundColor: '#E03100',
    textColor: '#ffffff',
    hoverTextColor: '#ffffff',
    hoverBackgroundColor: '#BE2900',
  },
  persistence: 'tab',
}
